/* eslint-disable react-hooks/exhaustive-deps */
import { Path } from "@common/constans";
import { IForecaWeatherInfo } from "@common/models";
import { ICity, IMedia } from "@common/models/CMS";
import { hideGoogleMarkerInfoWindow, showGoogleMarkerInfoWindow } from "@components/general/GoogleMap";
import Icon from "@components/general/Icon";
import OptimizedImage from "@components/general/OptimizedImage";
import Translate from "@service/Translate";
import { getAirportByCityName } from "@utilize/Format";
import { getRecentWeatherCondition } from "@utilize/Weather";
import { FC, useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { MapWidgetContext } from "./MapWidgetContext";

interface ICitySectionItemProps {
    onBackwardBtnClick?: (city: ICity) => void;
}

const CitySectionItem: FC<ICitySectionItemProps> = ({ onBackwardBtnClick }) => {
    const { tr } = Translate;
    const { push } = useHistory();
    const { state: { markerGroups, dataSource, currentCity } } = useContext(MapWidgetContext);
    const [weatherRecent, setWeatherRecent] = useState<IForecaWeatherInfo>();

    useEffect(() => {
        if (currentCity?.forecaWeatherId) {
            getRecentWeatherCondition(currentCity.forecaWeatherId)
                .then((response) => setWeatherRecent(response[currentCity.forecaWeatherId || 0]));
        }
    }, []);

    return (
        <div className="city-content">
            <div className="city-content-header flex flex-center justify-between">
                <div className="flex align-center">
                    <Icon
                        color="grey"
                        className="icon-backward"
                        name="icon-chevron-right"
                        size="36px"
                        flip
                        onClick={() => onBackwardBtnClick && onBackwardBtnClick(currentCity || {})}
                    />
                    <Link to={`${Path.Destinations}/${getAirportByCityName(currentCity?.name).cityCode}`} className="title-link">{currentCity?.name}</Link>
                </div>
                {
                    weatherRecent?.symb &&
                    <div className="flex align-center mof-3">
                        <img
                            className="mr-1"
                            alt="weather-icon"
                            src={`https://www.foreca.com/public/images/symbols/${weatherRecent?.symb}.svg`}
                            style={{ height: '30px' }}
                        />
                        <span className="en">{weatherRecent?.temp}&deg;c</span>
                    </div>
                }
            </div>
            <ul className="city-locations">
                {
                    dataSource.filter(x => x?.city?.contentItems.find(city => city.contentItemId === currentCity?.contentItemId)).map((location, index) =>
                        <li
                            key={index}
                            className="city-location"
                            onMouseEnter={() => showGoogleMarkerInfoWindow(location.localization?.localizationSet || "")}
                            onMouseLeave={() => hideGoogleMarkerInfoWindow(location.localization?.localizationSet || "")}
                            onClick={() => push(`${Path.Tourism.AttractionDetail}/${location.localization?.localizationSet}`)}
                        >
                            <div className="city-location-content">
                                <div className="cover">
                                    <OptimizedImage source={location?.cover || {} as IMedia} />
                                </div>
                                <div className="caption">
                                    {location.displayText}
                                </div>
                                <div className="tag">
                                    {tr(markerGroups.find(markerGroup => markerGroup.markers?.contentItems.some(x => x.contentItemId === location.localization?.localizationSet))?.markers?.contentItems
                                        .find(x => x.contentItemId === location.localization?.localizationSet)?.tag?.toLowerCase() || "")}
                                </div>
                            </div>
                        </li>
                    )
                }
            </ul>
        </div>
    )
}

export default CitySectionItem;